import { IconAngleLeft } from '@iwoca/icons';
import { Box } from '@iwoca/orion';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';

import { FUNDING_REQUIREMENTS_LIST_PATH } from '../../requirementStepPaths';

export const BackToListLink = () => {
    const { search } = useLocation();

    return (
        <Box paddingY="micro">
            <Link
                to={maintainStateKey({
                    pathname: FUNDING_REQUIREMENTS_LIST_PATH,
                    search
                })}
                className="inline-flex items-center gap-xs text-s font-bold text-primary-40"
            >
                <IconAngleLeft className="text-l" />
                <FormattedMessage
                    id="_.funding_requirements.inner_layout.back_to_list"
                    defaultMessage="Back to list"
                />
            </Link>
        </Box>
    );
};
